<mat-toolbar color="primary" class="header-toolbar">
  <!-- Global Navigation -->

  <nav class="global-nav">
    <ul class="global-nav">
      <li><a href="http://inside.chevron.com">Inside Home</a> </li>
      <li><a href="http://findandsearch.chevron.com/">Find &amp; Search</a> </li>
      <li><a href="http://whitepages.chevron.com/">People Finder</a> </li>
    </ul>
  </nav>

  <div class="header-container">
    <div class="logo-section">
      <img src="Images/sitename.png" alt="Site Name - Site Description" class="site-logo">
    </div>
    <div class="siteSpecific">
      <ul class="site-links">
        <li>
          <a target="_blank"
             href="https://chevron.sharepoint.com/sites/pmms/MIP/Forms/Section%20300.aspx">
            Maintenance &amp;
            Inspection Procedures
          </a>
        </li>
        <li>
          <a href="http://midstream.chevron.com/">
            Midstream Strategy &amp; Policy
          </a>
        </li>
      </ul>

      <img src="Images/ChevronExternal_Logo.png" alt="Hydrostatic App Logo" class="logo">
    </div>


  </div>


</mat-toolbar>


<!-- Banner Section -->
<div class="banner-section">
  <mat-card class="banner-card">
    <mat-card-header>
      <mat-card-title>
        <span [routerLink]="''" class="home-link">
          <mat-icon>home</mat-icon>
          CPL Home
        </span>
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <div class="banner-image">
        <img src="Images/banner-img.jpg" alt="Hydrostatic App Banner" class="banner-img">
      </div>
    </mat-card-content>
  </mat-card>
</div>
